<template>
  <div class="info-container">
    <div @mouseenter="showInfo = true" @mouseleave="showInfo = false" class="icon">
      <InfoIcon :fill="fill" class="w-5 h-5"></InfoIcon>
    </div>
    <div v-show="showInfo" class="info" :style="infoBlock">
      <div class="info-header mb-4">
        <div class="flex w-full items-center">
          <div class="flex w-3/4">
            <slot name="info-header"></slot>
          </div>
          <div class="w-1/4">
            <div class="flex justify-end">
              <InfoIcon fill="#FFFFFF"></InfoIcon>
            </div>
          </div>
        </div>
      </div>
      <div class="info-content">
        <slot name="info-content"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import InfoIcon from '@/Components/Icons/InfoIcon.vue';

export default {
  name: 'InfoTooltip',
  components: {
    InfoIcon,
  },
  props: {
    width: {
      type: String,
      require: false,
      default: '600',
    },
    fill: {
      type: String,
      require: false,
      default: '#0D9488',
    },
  },
  data() {
    return {
      showInfo: false,
    };
  },
  computed: {
    infoBlock() {
      return {
        'max-width': `${this.width}px`,
        width: `${this.width}px`,
        left: `${-(Number(this.width) + 20)}px`,
      };
    },
  },
};
</script>
<style scoped>
.info-container {
  position: relative;
  display: inline-block;
}

.icon {
  cursor: help;
}

.info {
  position: absolute;
  top: 0;
  background-color: #606367;
  color: #fff;
  padding: 20px;
  border-radius: 5px;
  z-index: 1000;
}

.info-header {
  color: '#C4C4C4';
  font-size: 12px;
}

.info-content {
  font-size: 14px;
}
</style>
